import React from 'react';
import { MinusIcon } from '@chakra-ui/icons';
import { Center, CenterProps } from '@chakra-ui/react';

import { CheckmarkIcon } from '../../styles/custom-icons';

type CircleCheckboxProps = {
  readonly isChecked?: boolean;
  // Renders a dash instead of a tick — used for "select all" partial selection states
  readonly isIndeterminate?: boolean;
  readonly isDisabled?: boolean;
  readonly onChange?: (isChecked: boolean) => void;
  readonly size?: string | number;
} & Omit<CenterProps, 'onChange'>;

export function CircleCheckbox({
  isChecked = false,
  isIndeterminate = false,
  isDisabled = false,
  onChange,
  size = '28px',
  ...centerProps
}: CircleCheckboxProps) {
  const isActive = isChecked || isIndeterminate;

  return (
    <Center
      as="button"
      type="button"
      role="checkbox"
      aria-checked={isIndeterminate ? 'mixed' : isChecked}
      disabled={isDisabled}
      w={size}
      minW={size}
      h={size}
      borderRadius="full"
      border="2px solid"
      borderColor={isActive ? 'primaryBranding.200' : 'customGrey.400'}
      bg={isActive ? 'primaryBranding.200' : 'transparent'}
      color="white"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? 0.4 : 1}
      transition="background 0.15s ease, border-color 0.15s ease"
      onClick={() => !isDisabled && onChange?.(!isChecked)}
      {...centerProps}
    >
      {isIndeterminate ? <MinusIcon w="60%" h="60%" /> : isChecked ? <CheckmarkIcon w="50%" h="50%" /> : null}
    </Center>
  );
}
